import { render } from "./Alert.vue?vue&type=template&id=018bd8a8&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=018bd8a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-018bd8a8"

export default script